import React, { useContext, useState } from 'react'
import { Row, Col } from 'react-bootstrap'
import styled from 'styled-components'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronRight } from '@fortawesome/free-solid-svg-icons'
import { Link } from 'react-router-dom'
import PropTypes from 'prop-types'
import i18n from 'i18n'
import ConnectedAccounts from './ConnectedAccounts'
import { getFromLocalStorage } from '../../../helper/storage'

// import { getFromLocalStorage } from '../../../helper/storage'
import { JazeelContext } from '../../../utils/JazeelContext'
import Card from 'react-bootstrap/Card'
import IconTo from 'components/IconTo'
import { RTL } from 'locales/currentLang'
import langUrl from '../../../../CampaignSystem/utils/langUrl'

const SocialAccountsContainer = styled(Card)`
  border-radius: 20px;
  background-color: #ffffff;
  box-shadow: 0 6px 26px 0 rgba(0, 0, 0, 0.08);
  border: none;
  &:hover {
    text-decoration: none;
  }
`
const ConnectButton = styled(Link)`
  height: 2.25em;
  width: 11.25em;
  display: block;
  line-height: 2.25em;
  text-align: center;
  border-radius: 5px;
  color: #ffffff;
  background: linear-gradient(45deg, #11bed3 0%, #9cdf61 100%);
  border: none;
  &:hover {
    text-decoration: none;
  }
  &.mobile {
    margin-left: 0;
    margin-top: 0.625em;
  }
`
export default function SocialAccounts({ accountsLength }) {
  const { isMobile } = useContext(JazeelContext)
  // const accounts = getFromLocalStorage('userData:').social_media_data
  // const [length, setLength] = useState(
  //   Object.keys(accounts).filter(account => accounts[account]).length,
  // )
  const [loading, setLoading] = useState(true)

  return (
    <SocialAccountsContainer>
      <Row className="card-body m-3 p-0">
        <Col xs={12} md={4} className="p-0">
          <h2 className="title">
            {/*{`${length || 'No Social'} Account${*/}
            {/*  length != 1 ? 's' : ''*/}
            {/*} Connected`}*/}
            {i18n.t('influencer.dashboard.social')}
          </h2>
        </Col>

        <Col xs={10} md={4} className="p-0">
          {accountsLength === 0 ? (
            <ConnectButton
              className={isMobile ? 'mobile' : ''}
              to={`/${langUrl}/influencer/social`}
            >
              {i18n.t('influencer.dashboard.connect-btn')}
            </ConnectButton>
          ) : (
            <Link className="description" to={`/${langUrl}/influencer/social`}>
              {accountsLength} {i18n.t('influencer.dashboard.connected')}
            </Link>
          )}
        </Col>

        {/*{isMobile ? (*/}
        {/*  ''*/}
        {/*) : (*/}
        {/*  <ConnectedAccounts*/}
        {/*    loading={loading}*/}
        {/*    setLoading={setLoading}*/}
        {/*    setLength={setLength}*/}
        {/*  />*/}
        {/*)}*/}
        {isMobile && (
          <Col className="arrow p-0">
            <Link to={`/${langUrl}/influencer/social`}>
              <IconTo direction={RTL().toString()} />
            </Link>
          </Col>
        )}
      </Row>
    </SocialAccountsContainer>
  )
}
SocialAccounts.propTypes = {
  accountsLength: PropTypes.number,
}
